<template lang="pug">

    .video-hover(:class="`video-hover--${realResize} ${typeClass}`", v-inview:class="['entered']")

        .video-hover__wrap(:style="style", :class="{fix: fix}", @click="toggleFix")

            .video-hover__ills
                app-image(:lazy-src="src", :lazy-srcset="srcset", :alt="object.image.alt", :class="imgClass")

                .video-hover__cta(v-if='object.image.src')
                    button(v-html="'->'")

            .video-hover__video
                //- app-video(:object="video", :base="base")
                app-image(:lazy-src="srcHover", :lazy-srcset="srcsetHover", :alt="object.image.alt", :class="imgClass")

</template>

<script>
/* Components */
import AppImage from '@/components/AppImage.vue';
import AppVideo from '@/components/AppVideo.vue';
// import InViewOffMixin from '@/assets/js/viscom/viscomjs/utils/InViewOffMixin';

export default {
    name: 'video-hover',
    props: {
        object: {
            type: Object,
            default: null
        },

        base: {
            type: String,
            default: ''
        },

        resize: {
            type: String,
            default: 'contain'
        }
    },

    components: {
        AppImage,
        AppVideo
    },

    data() {
        return {
            fix: false
        };
    },

    computed: {
        src() {
            return this.base + (this.object.image.src || '');
        },

        srcHover() {
            return this.base + (this.object.src || '');
        },

        width() {
            return this.object.image.width || null;
        },

        height() {
            return this.object.image.height || null;
        },

        realResize() {
            return this.object.image.customResize || this.resize;
        },

        typeClass() {
            if (!this.object.types || !(this.object.types instanceof Array)) return '';
            return 'video-hover--' + this.object.types.join(' video-hover--');
        },

        imgClass() {
            if (!this.width || !this.height) return '';
            return 'aspect-ratio';
        },

        srcCompact() {
            return this.base + (this.object.image.srcCompact || '');
        },

        srcCompactHover() {
            return this.base + (this.object.srcCompact || '');
        },

        srcset() {
            if (!this.srcCompact) return null;
            return `${this.src} 1400w, ${this.srcCompact} 800w`;
        },

        srcsetHover() {
            if (!this.srcCompact) return null;
            return `${this.srcHover} 1400w, ${this.srcCompactHover} 800w`;
        },

        aspectRatio() {
            // Calculate the aspect ratio of the image
            // if the width and the height are given.
            if (!this.width || !this.height) return null;

            return (this.height / this.width) * 100;
        },

        style() {
            const style = {height: '100%'};

            if (this.realResize === 'contain') return style;

            if (this.aspectRatio) {
                style.height = 0;
                style.paddingBottom = `${this.aspectRatio}%`;
            }

            return style;
        },

        video() {
            return {
                src: this.object.src
            };
        }
    },

    methods: {
        toggleFix() {
            this.fix = !this.fix;
        }
    }
};
</script>

<style lang="scss">
//
@import '../../assets/css/vars';
//
.video-hover {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__wrap {
        position: relative;
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        line-height: 0;

        &:hover {
            .video-hover__video {
                opacity: 1;
            }
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            height: auto !important;
            padding-bottom: 0 !important;

            &:hover {
                .video-hover__video {
                    opacity: 0;
                }
            }

            &.fix {
                .video-hover__video {
                    opacity: 1;
                }
            }
        }
    }

    &__ills {
        position: relative;
    }

    &__cta {
        position: absolute;
        top: calc(50% - 1.5em);
        left: 0;
        color: var(--color-text-over-accent);
        width: 3.6em;
        height: 3em;
        background-color: var(--color-accent-strong);
        z-index: 2;
        pointer-events: none;
        animation: accent-strong-bg-blink-short 0.2s linear infinite both;

        &::before,
        &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            transform-origin: 0 0;
        }

        &:after {
            background: var(--color-accent);
            opacity: 0.7;
            z-index: 0;
            animation: noise-anim 2s infinite linear alternate-reverse;
        }

        &:before {
            background: #da9b1b;
            opacity: 0.5;
            z-index: 0;
            animation: noise-anim 5s infinite linear alternate-reverse;
        }

        &.disabled {
            animation: none;

            &::before,
            &::after {
                display: none;
                animation: none;
            }
        }

        button {
            font-size: 1.7em;
            padding: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            &:disabled {
                color: var(--color-text-over-accent);
            }
        }
    }

    .app-image {
        background-color: rgba(255, 255, 255, 0.1);
        width: 100%;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            max-height: unset;
            width: 100%;
        }
    }

    // TYPES:
    &--width-80 {
        .app-image {
            width: 80%;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 100%;
            }
        }
    }

    &--width-69 {
        .app-image {
            width: 69%;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 100%;
            }
        }
    }

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        &--mobile-car {
            .video-hover {
                &__wrap {
                    height: 0 !important;
                    padding-bottom: 100% !important;
                    overflow: hidden;
                }
            }

            .app-image {
                position: absolute;
                top: 50%;
                left: 0;
                bottom: 0;
                transform: translate(-20%, -50%);
                width: auto;
                max-width: unset;
                height: 100%;

                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    position: relative;
                    top: auto;
                    left: auto;
                    transform: none;
                }
            }
        }
    }

    // ALIGN
    &--right {
        align-items: flex-end;

        .video-hover {
            &__wrap {
                align-items: flex-end;
            }
        }
    }

    // Enter animation
    &--alpha {
        transition: opacity 0.3s ease 0.15s;

        &:not(.entered) {
            opacity: 0;
        }
    }

    &__video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0;
        transition: opacity 0.3s ease;
    }
}
</style>
